"use client";

type DietaryRestrictionsFieldProps = {
  value?: string;
  onChange: (restrictions: string) => void;
  error?: string;
};

export function DietaryRestrictionsField({ value, onChange, error }: DietaryRestrictionsFieldProps) {
  return (
    <div>
      <label className="block text-sm font-medium mb-1">Dietary Restrictions or Preferences</label>
      <textarea
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        rows={2}
        className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
        placeholder="Any dietary restrictions, allergies, or preferences"
      />
      {error && <p className="mt-1 text-sm text-destructive">{error}</p>}
    </div>
  );
}
